import { Link } from "react-router-dom"
import MarketingCta from "../../components/marketing/MarketingCta"
import MarketingLayout from "../../components/marketing/MarketingLayout"
import MarketingSeo from "../../components/marketing/MarketingSeo"
import { ascTuneUpScaleMailto } from "../../components/marketing/salesLinks"
import { Button } from "../../components/ui"

const automotiveAreas = [
  ["Dealership accounts", "Organize websites, properties, and platforms around each rooftop"],
  ["Automotive audits", "Run GA4, tagging, data-quality, and paid-media checks"],
  ["Dealership status", "See tagging, GA4, and paid-media issues across the group"],
  ["ASC TuneUp Scale", "Coming soon: custom checks and selected GA4 configuration updates"],
]

export default function MarketingAscTuneUp() {
  return (
    <MarketingLayout>
      <MarketingSeo
        title="ASC TuneUp by Jarbod | Automotive Analytics QA"
        description="ASC TuneUp is Jarbod’s automotive-specific measurement audit product for dealerships, dealer groups, and automotive agencies."
        path="/asc-tuneup"
      />
      <section className="marketing-hero marketing-hero--automotive">
        <div className="marketing-container marketing-hero__grid">
          <div>
            <p className="marketing-eyebrow">ASC TuneUp by Jarbod · Automotive</p>
            <h1 className="marketing-title">
              Keep every dealership’s <span className="marketing-title__accent">measurement stack</span> in tune.
            </h1>
            <p className="marketing-lede">
              Catch dealership tagging, GA4, and paid-media issues before they
              reach rooftop or group reporting. ASC TuneUp keeps every website,
              property, and advertising account organized by dealership.
            </p>
            <div className="marketing-actions">
              <MarketingCta size="lg">Start ASC TuneUp trial</MarketingCta>
              <Button as={Link} to="/asc-tuneup/features" variant="outline" size="lg">
                Explore automotive features
              </Button>
            </div>
            <ul className="marketing-proof" aria-label="ASC TuneUp details">
              <li>Core from $100 per dealership / month</li>
              <li>ASC TuneUp Scale coming soon</li>
            </ul>
          </div>

          <div className="marketing-console" aria-label="Example ASC TuneUp dealership audit summary">
            <div className="marketing-console__chrome" aria-hidden="true"><span /><span /><span /></div>
            <div className="marketing-console__body">
              <div className="marketing-console__topline"><span className="marketing-console__label">Dealership portfolio</span><span className="marketing-console__status">48 rooftops checked</span></div>
              <div className="marketing-console__metric"><div className="marketing-console__score">92<small>/100</small></div><div className="marketing-console__bar" aria-hidden="true"><span /></div></div>
              <div className="marketing-console__rows">
                <div className="marketing-console__row"><span>GA4 settings</span><strong>On standard</strong></div>
                <div className="marketing-console__row"><span>Website tagging</span><strong>6 issues</strong></div>
                <div className="marketing-console__row"><span>GA4 settings</span><strong>4 to review</strong></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="marketing-foundation" aria-label="ASC TuneUp product areas">
        <div className="marketing-container marketing-foundation__grid">
          {automotiveAreas.map(([title, detail]) => <div className="marketing-foundation__item" key={title}><strong>{title}</strong><span>{detail}</span></div>)}
        </div>
      </section>

      <section className="marketing-section">
        <div className="marketing-container marketing-product-list">
          <article className="marketing-product-card">
            <div className="marketing-product-card__intro"><span>01</span><div><p className="marketing-product-kicker">ASC TuneUp Core</p><h2>Proven dealership tagging and analytics checks.</h2><p>Use automotive-ready audits and rooftop organization without designing a custom checklist.</p></div></div>
            <ul><li>Dealership and rooftop account model</li><li>GA4, website, tagging, and paid-media audits</li><li>Daily checks and shared account visibility</li><li>Seven-day eligible trial</li></ul>
          </article>
          <article className="marketing-product-card" id="scale">
            <div className="marketing-product-card__intro"><span>02</span><div><p className="marketing-product-kicker">ASC TuneUp Scale · Coming soon</p><h2>Your dealership standard, checked across every rooftop.</h2><p>Scale is planned to add custom audit checks, configuration targets for dealership accounts, and cross-account monitoring.</p></div></div>
            <ul><li>Planned custom audit checks</li><li>Planned configuration targets for dealership accounts</li><li>Planned monitoring across selected rooftops</li><li>Planned support for selected GA4 configuration updates across chosen dealership accounts</li></ul>
          </article>
        </div>
      </section>

      <section className="marketing-section marketing-section--surface">
        <div className="marketing-container marketing-split-feature">
          <div>
            <p className="marketing-eyebrow">Built for automotive operations</p>
            <h2>One view across websites, analytics, ads, and vendors.</h2>
            <p className="marketing-copy">Keep rooftop work separated while giving the group or agency a consistent view of tagging, GA4, and paid-media status across every dealership.</p>
            <Button as={Link} to="/asc-tuneup/features" variant="outline">See all ASC TuneUp features</Button>
          </div>
          <div className="marketing-signal-board" aria-label="Example dealership portfolio">
            <div className="marketing-signal-board__header"><span>Dealership health</span><strong>4 shown</strong></div>
            {[["Northside Motors", "On standard", "96"],["Lakeview Auto", "Fix ready", "84"],["Metro Imports", "On standard", "93"],["Pine Ridge Cars", "Review", "88"]].map(([name,status,score]) => <div className="marketing-signal-board__row" key={name}><span className="marketing-signal-board__dot" aria-hidden="true" /><strong>{name}</strong><span>{status}</span><b>{score}</b></div>)}
          </div>
        </div>
      </section>

      <section className="marketing-section marketing-section--cta">
        <div className="marketing-container marketing-cta-panel">
          <div><p className="marketing-eyebrow">Built for your rooftops</p><h2>Start with Core today. Follow what is coming in Scale.</h2></div>
          <div className="marketing-actions">
            <Button as={Link} to="/asc-tuneup/pricing" size="lg">View ASC TuneUp pricing</Button>
            <Button as="a" href={ascTuneUpScaleMailto} variant="outline" size="lg">Ask about ASC TuneUp Scale</Button>
          </div>
        </div>
      </section>
    </MarketingLayout>
  )
}

